<template>
  <div class="detial">
    <el-card class="box-card">
      <div style="padding: 20px;">
        <div style="display:flex">
          <span class="chapterPracticeTitle">初级会计职称</span>
          <div class="titleButton" v-popover:popover2>切换科目</div>
        </div>
        <el-divider></el-divider>
        <div class="chapterPractice">
          <el-button type="text" class="buttonType" id="button01">
            <i class="icon iconfont icon-zhangjie"></i> 章节练习
          </el-button>
          <el-button type="text" class="buttonType" id="button02">
            <i class="icon iconfont icon-mokao"></i> 模拟考试
          </el-button>
        </div>
      </div>
      <el-popover ref="popover2" placement="bottom" width="200" trigger="click">
        <div class="popovers">
          <div class="title">
            <div class="name">初级会计职称-初级会计实务</div>
            <div class="change" @click="dialogTableVisible = true">切换考试</div>
          </div>
          <div v-for="(item,index) in 4" :key="index">
            <div class="content">
              <span>经济法基础</span>
              <i class="iconfont icondui" style="color: rgb(199, 0, 10) !important;font-size:12px;"></i>
            </div>
          </div>
        </div>
      </el-popover>

      <div class="block">
        <el-table
          :header-cell-style="{background:'#fafafa',fontSize:'13px',fontWeight:400}"
          :data="pageList"
          style="width: 100%;margin-bottom: 20px;"
          row-key="id"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        >
          <el-table-column prop="label" label="章节" min-width="70%">
            <template slot-scope="row">
              <span v-if="row.row.lever!=3">{{row.row.label}}</span>
              <span v-else>
                <span>{{row.row.label}}</span>
                <div class="rate-flex">
                  <div class="rate-flex-a">
                    考频：
                    <el-rate
                      class="rate-margin-top"
                      disabled
                      v-model="row.row.lever"
                      :colors="colors"
                    ></el-rate>
                  </div>
                  <div class="rate-flex-a">
                    掌握：
                    <el-rate
                      class="rate-margin-top"
                      disabled
                      v-model="row.row.lever"
                      :colors="colors"
                    ></el-rate>
                  </div>
                </div>
              </span>
            </template>
          </el-table-column>

          <el-table-column prop="lever" label="已做/总题" min-width="10%" align="center">
            <template slot-scope="row">
              <span style="font-size:13px;color:#a2aabc">0/{{row.row.lever}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog title="切换考试" :visible.sync="dialogTableVisible" width="60%">
        <div v-for="(item,index) in 4" :key="index">
          <div class="subjectText">财会类</div>
          <div style="display:flex;flex-wrap:wrap;">
            <div class="subjectType" v-for="(item,index) in 6" :key="index">
              <div class="type" @click="typeClick()">初级会计级会计职称</div>
            </div>
          </div>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogTableVisible: false,
      pageList: [
        {
          label: "第一章  会计概述",
          lever: "1",
          id: 1,
          children: [
            {
              id: 11,
              label: "2019年初会经济法基础考前密押61题（一）",
              lever: 2,
              children: [
                {
                  id: 111,
                  label: "2019年初会经济法基础考前密押61题（二）",
                  lever: 3
                },
                {
                  id: 112,
                  label: "2019年初会经济法基础考前密押61题（二）",
                  lever: 3
                },
                {
                  id: 113,
                  label: "2019年初会经济法基础考前密押61题（二）",
                  lever: 3
                }
              ]
            }
          ]
        },
        {
          label: "第二章  会计概述",
          lever: "1",
          id: 2,
          children: [
            {
              id: 21,
              label: "2019年初会经济法基础考前密押61题（一）",
              lever: "2"
            },
            {
              id: 22,
              label: "2019年初会经济法基础考前密押61题（一）",
              lever: "2"
            }
          ]
        }
      ],
      colors: ["rgb(35,212,151)", "rgb(255,206,40)", "rgb(252,94,94)"]
    };
  },
  methods: {
    goChapter() {
      this.$router.push({ path: "/chapter" });
      this.routeDecide();
    },
    goPracticeTest() {
      this.$router.push({ path: "/practiceTest" });
      this.routeDecide();
    },
    typeClick() {},
    goErrorBank() {
      this.$router.push({ path: "/errorBank" });
      this.routeDecide();
    },
    goBookMark() {
      this.$router.push({ path: "/bookMark" });
      this.routeDecide();
    },
    goErrorRecovery() {
      this.$router.push({ path: "/errorRecovery" });
      this.routeDecide();
    },
    routeDecide() {
      if (this.$route.path == "/chapter") {
        document.getElementById("button01").classList.add("select-buttonType");
        document
          .getElementById("button02")
          .classList.remove("select-buttonType");
        document
          .getElementById("button03")
          .classList.remove("select-buttonType");
        document
          .getElementById("button04")
          .classList.remove("select-buttonType");
        document
          .getElementById("button05")
          .classList.remove("select-buttonType");
      } else if (this.$route.path == "/practiceTest") {
        document.getElementById("button02").classList.add("select-buttonType");
        document
          .getElementById("button01")
          .classList.remove("select-buttonType");
        document
          .getElementById("button03")
          .classList.remove("select-buttonType");
        document
          .getElementById("button04")
          .classList.remove("select-buttonType");
        document
          .getElementById("button05")
          .classList.remove("select-buttonType");
      } else if (this.$route.path == "/errorBank") {
        document.getElementById("button03").classList.add("select-buttonType");
        document
          .getElementById("button02")
          .classList.remove("select-buttonType");
        document
          .getElementById("button01")
          .classList.remove("select-buttonType");
        document
          .getElementById("button04")
          .classList.remove("select-buttonType");
        document
          .getElementById("button05")
          .classList.remove("select-buttonType");
      } else if (this.$route.path == "/bookMark") {
        document.getElementById("button04").classList.add("select-buttonType");
        document
          .getElementById("button02")
          .classList.remove("select-buttonType");
        document
          .getElementById("button03")
          .classList.remove("select-buttonType");
        document
          .getElementById("button01")
          .classList.remove("select-buttonType");
        document
          .getElementById("button05")
          .classList.remove("select-buttonType");
      } else if (this.$route.path == "/errorRecovery") {
        document.getElementById("button05").classList.add("select-buttonType");
        document
          .getElementById("button02")
          .classList.remove("select-buttonType");
        document
          .getElementById("button03")
          .classList.remove("select-buttonType");
        document
          .getElementById("button04")
          .classList.remove("select-buttonType");
        document
          .getElementById("button01")
          .classList.remove("select-buttonType");
      }
    }
  },
  mounted() {
    this.routeDecide();
  }
};
</script>
<style scoped>
.box-card {
  min-height: 400px;
  width: 100%;
  margin: auto;
  padding: 0px;
  border-width: 0px;
}
.node-button {
  border: 1px solid rgba(238, 238, 238, 1);
  width: 80px;
  height: 32px;
  text-align: center;
  line-height: 30px;
  border-radius: 4px;
  color: #455a64;
  font-size: 13px;
}
.node-button:hover {
  color: #fff;
  cursor: pointer;
  background-color: rgba(199, 0, 10, 1);
}
.bofang-type {
  font-size: 20px;
}
.bofang-type:hover {
  cursor: pointer;
  color: rgba(199, 0, 10, 1);
}
.rate-flex {
  display: flex;
  margin-left: 50px;
  font-size: 12px;
  color: #a2aabc;
}
.rate-flex-a {
  display: flex;
  margin-right: 50px;
}
.rate-margin-top {
  margin-top: 1px;
}
</style>
<style lang="less" rel="stylesheet/less">
.detial {
  .block {
    .el-table__expand-icon--expanded {
      -webkit-transform: rotate(0deg) !important;
      transform: rotate(0deg) !important;
    }
  }
  .el-table .el-icon-arrow-right:before {
    content: "\e7a0";
    font-size: 20px;
    border-radius: 50%;
  }
  .el-table .el-table__expand-icon--expanded .el-icon-arrow-right:before {
    content: "\e7a2";
    font-size: 20px;
  }
  .el-table .el-table__expand-icon {
    color: rgba(199, 0, 10, 1);
  }
  .el-table .el-table__expand-icon.is-leaf {
    color: transparent;
  }
}
</style>

<style  lang="less"  scoped>
.box-card {
  margin: auto;
}
// .popovers {
//   .title {
//     display: flex;
//     flex-direction: row;
//     justify-content: space-between;
//     align-items: center;
//   }
// }
.chapterPracticeTitle {
  font-size: 18px;
  font-weight: 800;
}
.titleButton {
  border: 1px solid rgba(238, 238, 238, 1);
  border-radius: 4px;
  text-align: center;
  line-height: 26px;
  height: 26px;
  width: 80px;
  font-size: 13px;
  margin-left: 20px;
}
.titleButton:hover {
  border-color: rgba(199, 0, 10, 1);
  color: rgba(199, 0, 10, 1);
  cursor: pointer;
}
.buttonType {
  margin-right: 20px;
}
.buttonType:hover {
  color: rgba(199, 0, 10, 1);
  cursor: pointer;
}
.select-buttonType {
  color: rgba(199, 0, 10, 1) !important;
}
.subjectType {
  margin-top: 20px;
  margin-right: 20px;
}
.subjectText {
  font-size: 16px;
  width: 50px;
  margin-top: 20px;
}
.type {
  font-size: 13px;
  border: 1px solid rgba(238, 238, 238, 1);
  width: 150px;
  border-radius: 55px;
  height: 40px;
  text-align: center;
  line-height: 40px;
}
.type:hover {
  border-color: rgba(199, 0, 10, 1);
  color: rgba(199, 0, 10, 1);
  cursor: pointer;
}
.change:hover {
  cursor: pointer;
  color: rgba(199, 0, 10, 1);
}
</style>
<style lang="less" rel="stylesheet/less">
.detial {
  .el-popover {
    width: 300px !important;
  }

  .popovers .title {
    display: flex !important;
    flex-direction: row !important;
    justify-content: space-between !important;
    align-items: center !important;
    border-bottom: 2px solid #eee !important;
    padding-bottom: 6px;
  }

  .popovers .title .name {
    font-size: 18px !important;
    color: #455a64 !important;
  }

  .popovers .title .change {
    color: #999;
    font-size: 12px;
  }

  .popovers .content span {
    color: #455a64;
    font-size: 12px;
    line-height: 30px;
  }

  .popovers .content {
    display: flex;
    justify-content: space-between;
    line-height: 30px;
    align-items: center;
  }
  .chapterPractice {
    .el-button--text {
      color: #303133;
    }
    .el-button span {
      font-size: 14px !important;
    }
  }
  .el-dialog__body {
    padding-top: 0px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/condition/detial.vue